import React, {Component} from 'react';
import styles from './ImageUploader.scss';
import classNames from 'classnames';
import {func, string} from 'prop-types';
import {FauxIconButton} from '@sinclair-digital/sbg-storyline-components/src/components/IconButton';
import {default as UploadButton} from '@sinclair-digital/sbg-storyline-components/src/components/UploadButton';
import {Spinner} from '@sinclair-digital/sbg-storyline-components/src/components/Loading';
import {upload} from 'react-icons-kit/fa/upload';
class ImageUploader extends Component {
    static propTypes = {
        className: string,
        imageUrl: string,
        label: string,
        uploadImage: func.isRequired,
    };

    static defaultProps = {
        imageUrl: '',
    };

    state = {
        isLoading: false,
    };

    componentWillReceiveProps(nextProps) {
        if (nextProps.imageUrl !== this.props.imageUrl) {
            this.setState({isLoading: false});
        }
    }

    /**
     * Uploads an image to the Uploader
     * @method uploadImage
     * @param  {Filelist}    files
     * @return {void}
     */
    uploadImage = files => {
        const {uploadImage} = this.props;
        if (files && files.length && uploadImage) {
            this.setState({isLoading: true});
            uploadImage(files[0]);
        }
    };

    render() {
        const {className, imageUrl, label} = this.props;
        const containerClasses = classNames(styles.ImageUploader, className, {
            [styles.placeholder]: !imageUrl,
        });
        return (
            <div className={containerClasses}>
                {imageUrl ? <img src={imageUrl} /> : ''}
                {label && <span className={styles.label}>{label}</span>}
                {this.state.isLoading && (
                    <div className={styles.loading}>
                        <Spinner size={85} />
                    </div>
                )}
                {!this.state.isLoading && (
                    <div className={styles.overlay}>
                        <UploadButton
                            onFilesSelected={this.uploadImage}
                            className={styles.upload}
                            label="upload"
                            accept="image/*">
                            <FauxIconButton icon={upload} theme="primary" className={styles.uploadButton} />
                        </UploadButton>
                    </div>
                )}
            </div>
        );
    }
}

export default ImageUploader;
